export const capitalizeEachWord = (sentence: string) => {
    const array = sentence.split(' ')
    for (let i = 0; i < array.length; i++) {
        array[i] = array[i].charAt(0).toUpperCase() + array[i].slice(1)
    }
    const finalString = array.join(' ')
    return finalString
}

